import { Stack, Switch, Typography, useTheme } from "@mui/material";
import { FLAT_ROW_MIN_HEIGHT } from "web_myplann/Shared/Components/FlatRow/constants";

export type FlatRowSwitchProps = {
	label: string;
	checked?: boolean;
	onChange?: (checked: boolean) => void;
	onBlur?: () => void;
	disabled?: boolean;
	isLast?: boolean;
	redesigned?: boolean;
	labelVariant?: "body2" | "bodyMedium";
};

export const FlatRowSwitch = ({
	label,
	checked,
	onChange,
	onBlur,
	disabled,
	isLast,
	redesigned = false,
	labelVariant = "body2",
}: FlatRowSwitchProps) => {
	const { palette, spacingTokens } = useTheme();

	return (
		<Stack
			component="label"
			direction="row"
			alignItems="center"
			justifyContent="space-between"
			width="100%"
			px={spacingTokens.lg}
			minHeight={FLAT_ROW_MIN_HEIGHT}
			borderBottom={isLast ? "none" : `1px solid ${palette.surface.border}`}
			sx={{ cursor: disabled ? "default" : "pointer" }}
		>
			<Typography variant={labelVariant} mr={spacingTokens.xl}>
				{label}
			</Typography>
			<Switch
				redesigned={redesigned}
				checked={!!checked}
				onChange={(_, next) => onChange?.(next)}
				onBlur={onBlur}
				disabled={disabled}
			/>
		</Stack>
	);
};
